// extracted by mini-css-extract-plugin
module.exports = {"content":"checkboxAgreeFooter_content__mK1SU","checkbox":"checkboxAgreeFooter_checkbox__1bLaS"};
    if(module.hot) {
      // 1790670239692
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  